import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ApiEndPoint } from 'src/configurations/constants';
import { PreferenceKeys } from 'src/app/interfaces/preference-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class JobsService {
  httpOptions;
  httpBoday = '';
  ValueForJobAvailableFilter;
  paginationValue = 1;
  pageIndex = 1;
  pageSize = 10;
  ValueForFilterJobListingData;
  data;
  tokenData;
  countrieValue;
  getLink: any;

  private jobCreatedSubject$ = new Subject<boolean>();
  public jobCreated$ = this.jobCreatedSubject$.asObservable();

  constructor(private http: HttpClient) {}

  didCreateNewJob() {
    this.jobCreatedSubject$.next(true);
  }

  // job creation api start
  getResources(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Common.resources, this.httpOptions);
  }

  getCustomFields(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.CustomFields.Jobs.fields, this.httpOptions);
  }

  getJobTypeData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.types, this.httpOptions);
  }

  getJobLevelData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.levels + `/${jid}`, this.httpOptions);
  }

  getEducationLevelData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.educationLevels, this.httpOptions);
  }

  getEEOJobCategoryData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.eeoCategories, this.httpOptions);
  }

  getLanguageData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.languages, this.httpOptions);
  }

  getHiringManagerData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.HiringManagers.all + `/${jid}`,
      this.httpOptions
    );
  }

  getSalType() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.salary, this.httpOptions);
  }

  getJobRecruitersData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.Recruiters.all + `/${jid}`,
      this.httpOptions
    );
  }

  getSalaryRange() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.salaryRange + `/${jid}`, this.httpOptions);
  }

  // getjobLocation() {
  //   const token = localStorage.getItem('token');
  //   const jid = localStorage.getItem('jid');
  //   this.httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       Accept: 'application/json',
  //       authorization: token,
  //       'language-iso': 'en',
  //     }),
  //   };

  //   return this.http.get<any>(salaryRange + `/${jid}`, this.httpOptions);
  // }

  getShift() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    const iso = localStorage.getItem(PreferenceKeys.SelectedLanguage) ?? 'en';

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': iso,
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.shifts + `/${jid}`, this.httpOptions);
  }

  getJobLocation() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.location + `/${jid}`, this.httpOptions);
  }

  getpretex() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.preText + `/${jid}`, this.httpOptions);
  }

  getKeyword() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.Keywords.all + `/${jid}`,
      this.httpOptions
    );
  }

  getResource() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.Resources.all + `/${jid}`,
      this.httpOptions
    );
  }

  getPreQuestion() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.PreQuestions.all + `/${jid}`, this.httpOptions);
  }

  getScoreCard() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.scorecard + `/${jid}`, this.httpOptions);
  }

  getyearofExperience() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.experienceYears + `/${jid}`,
      this.httpOptions
    );
  }

  getCustomFieldJob() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.customFields, this.httpOptions);
  }

  getJobTemplate() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.JobTemplates.templates, this.httpOptions);
  }

  getJobCategory() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.categories, this.httpOptions);
  }

  getJobSubCategory(id) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.subcategories + `/${id}`,
      this.httpOptions
    );
  }

  getJobKeyword() {
    const token = localStorage.getItem('token');
    const iso = localStorage.getItem(PreferenceKeys.SelectedLanguage) ?? 'en';

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': iso,
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Keywords.all, this.httpOptions);
  }

  getJobDuration() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.durations, this.httpOptions);
  }

  getJobTravelFrequency() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.travelFrequencies, this.httpOptions);
  }

  getJobExpirationDate() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.expirationDates, this.httpOptions);
  }

  getJobConfidential() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.confidentials, this.httpOptions);
  }

  getCostCenter() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.customFields, this.httpOptions);
  }

  getJobCurrency() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.currencies, this.httpOptions);
  }

  getAvailableScorecard() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Scorecards.all, this.httpOptions);
  }

  getPreQuestions() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.PreQuestions.all, this.httpOptions);
  }

  // Api JobLanding Start Here
  getJobsState() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Dashboard.statistics, this.httpOptions);
  }

  getJobsChartData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Dashboard.chart, this.httpOptions);
  }

  getJobsAvailabledata() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Dashboard.availables, this.httpOptions);
  }

  getJobsAvailableDataByFilter() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.Dashboard.availables +
        `?cat=${this.ValueForJobAvailableFilter}&recordsPerPage=9&page=${this.paginationValue}`,
      this.httpOptions
    );
  }

  getValueForJobAvailableFilter(value) {
    this.ValueForJobAvailableFilter = value;
  }

  getValueForPaginationJobAvailable(value) {
    this.paginationValue = value;
  }

  setValueForSelectedJobsList(value) {
    this.data = value;
  }

  getValueForSelectedJobsList() {
    return this.data;
  }

  getMainJobBoardCount() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid') ? localStorage.getItem('jid') : '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.Dashboard.sites + `/${jid}`,
      this.httpOptions
    );
  }

  getSavedJobs() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.save, this.httpOptions);
  }

  deleteSave(jid) {
    const token = localStorage.getItem('token');
    const body = {
      jid: jid,
    };

    // const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.save + '/delete', body, this.httpOptions);
  }
  // Api JobLanding End Here

  // Api JobListing Start
  getAllJobs(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.all + `?recordsPerPage=10000&page=1`,
      this.httpOptions
    );
  }

  getJobsData(BUData) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    if (BUData) {
      return this.http.get<any>(
        ApiEndPoint.Jobs.all +
          `?recordsPerPage=${this.pageSize}&page=${this.pageIndex}&CatID=${BUData.CatID}&Cat=${BUData.cat}`,
        this.httpOptions
      );
    } else {
      return this.http.get<any>(
        ApiEndPoint.Jobs.all + `?recordsPerPage=${this.pageSize}&page=${this.pageIndex}`,
        this.httpOptions
      );
    }
  }

  getValueOfPagination(pageIndex, pageSize) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
  }

  setValueOfPagination(pageIndex: number, pageSize: number) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
  }

  getPowerUserJobsData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.owners, this.httpOptions);
  }

  getBusinessUnitJobsData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.businessUnits, this.httpOptions);
  }

  getDepartmentsJobsData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.departments, this.httpOptions);
  }

  getHiringManagersData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.HiringManagers.all, this.httpOptions);
  }

  getRecruitersData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Recruiters.all, this.httpOptions);
  }

  getPowerUsersData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.powerUsers, this.httpOptions);
  }

  getValueForFilterJobListingData(value) {
    this.ValueForFilterJobListingData = value;
  }

  setJobStatus(value) {
    this.ValueForFilterJobListingData = value;
  }

  getJobsDataByStatusFilter() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.all +
        `?status=${this.ValueForFilterJobListingData}&recordsPerPage=${this.pageSize}&page=${this.pageIndex}`,
      this.httpOptions
    );
  }

  getJoblistingDatabuStastus() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      hearders: new HttpHeaders({
        'content-type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.all +
        `?status=${this.ValueForFilterJobListingData}&recordsPerPage=${this.pageSize}&page=${this.pageIndex}`,
      this.httpOptions
    );
  }
  // Api Joblisting End

  // Api JobDetail Start Here
  getJobDetailData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.details + `/${jid}`, this.httpOptions);
  }

  getJobBoardCountData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.board + `/${jid}`, this.httpOptions);
  }

  getNotificationData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.notifications + `/${jid}`,
      this.httpOptions
    );
  }

  getJobNotification() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Dashboard.notifications, this.httpOptions);
  }

  getJobAlert() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.Dashboard.alerts, this.httpOptions);
  }

  getJobAiCountData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.aiBots + `/${jid}`, this.httpOptions);
  }

  getJobDetailWorkFlowCount() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.flowStatistics + `/${jid}`,
      this.httpOptions
    );
  }

  getHiringManagerByJob() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.HiringManagers.allInJob + `/${jid}`,
      this.httpOptions
    );
  }

  UpdateHiringManagerByJob(hiringMangerBody) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.HiringManagers.update + `/${jid}`,
      hiringMangerBody,
      this.httpOptions
    );
  }

  getRecruiterByJob() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.Recruiters.all + `/${jid}`,
      this.httpOptions
    );
  }

  UpdateRecruiterByJob(recruiterBody) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.Recruiters.update + `/${jid}`,
      recruiterBody,
      this.httpOptions
    );
  }

  getJobDetailChartData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.chart + `/${jid}`, this.httpOptions);
  }

  updateJobDetailActiveInactive(jobaction) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.action + `/${jid}`,
      jobaction,
      this.httpOptions
    );
  }

  updateJobclose(jobaction) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.action + `/${jid}`,
      jobaction,
      this.httpOptions
    );
  }

  updateJobDelete(jobaction) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.action + `/${jid}`,
      jobaction,
      this.httpOptions
    );
  }

  updateJobclone(jobaction) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.action + `/${jid}`,
      jobaction,
      this.httpOptions
    );
  }

  updateResources(resources) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(
      ApiEndPoint.Jobs.Resources.update,
      resources,
      this.httpOptions
    );
  }

  updateJobDetailKeyword(jobaction) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.Keywords.update + `/${jid}`,
      jobaction,
      this.httpOptions
    );
  }

  saveJob() {
    const tokenData = localStorage.getItem('token');
    const body = {
      jid: localStorage.getItem('jid'),
    };
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.save + '/add', body, this.httpOptions);
  }

  deleteJob() {
    const tokenData = localStorage.getItem('token');
    const body = {
      jid: localStorage.getItem('jid'),
    };
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.save + '/delete', body, this.httpOptions);
  }

  deleteJobFromList(jid) {
    const tokenData = localStorage.getItem('token');
    const body = {
      jid: jid,
    };
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.delete, body, this.httpOptions);
  }

  getJobSaveStatus() {
    const tokenData = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.save + `/${jid}`, this.httpOptions);
  }

  removeJobNotification(body) {
    const tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.notifications, body, this.httpOptions);
  }

  // Api JobDetail End
  getCountriesData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        // authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Common.countries, this.httpOptions);
  }

  getStateData(countryId): Observable<any> {
    this.tokenData = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      // authorization: this.tokenData,
      'language-iso': 'en',
    };

    return this.http.get<any>(ApiEndPoint.Common.states + `?country=${countryId}`, {
      headers,
    });
  }

  // Add job API's Start
  // Job Creation EndPoints
  postJobCreation(creationBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Jobs.insert, creationBody, this.httpOptions);
  }

  updateJobCreation(updationBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.update, updationBody, this.httpOptions);
  }

  updateJobParam(data) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.Jobs.inline + `/${jid}`,
      data,
      this.httpOptions
    );
  }

  postjobShare(shareBody) {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.Jobs.share, shareBody, this.httpOptions);
  }

  getJobShareSource(): Observable<any> {
    const tokenData = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.share + `/${jid}`, this.httpOptions);
  }

  getJobRecruitFlow(jid, flownum): Observable<any> {
    const tokenData = localStorage.getItem('token');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.Jobs.workflows + `/${jid}/${flownum}`,
      this.httpOptions
    );
  }

  getJobHistory(): Observable<any> {
    const tokenData = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Jobs.history + `/${jid}`, this.httpOptions);
  }

  getJobApprovalHistory(): Observable<any> {
    const tokenData = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.JobApprovals.history + `/${jid}`,
      this.httpOptions
    );
  }

  jobApprovalCreation(creationBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(
      ApiEndPoint.JobApprovals.approvals,
      creationBody,
      this.httpOptions
    );
  }

  jobApprovalUpdate(creationBody) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.JobApprovals.approvals,
      creationBody,
      this.httpOptions
    );
  }

  getJobApprovals() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.JobApprovals.approvals, this.httpOptions);
  }

  getJobApprovalDetailData() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      ApiEndPoint.JobApprovals.approvals + `/${jid}`,
      this.httpOptions
    );
  }

  updateJobApprovalDelete() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.JobApprovals.delete,
      { jid: jid },
      this.httpOptions
    );
  }

  jobApprovalResend() {
    const token = localStorage.getItem('token');
    const jid = localStorage.getItem('jid');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(
      ApiEndPoint.JobApprovals.resent,
      { jid: jid },
      this.httpOptions
    );
  }
}
